// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cYogZfEaHc9LfO {
  display: flex;
  position: relative;
  box-sizing: border-box;
  flex-basis: 272px;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: start;
  justify-content: space-between;
  width: 272px;
  max-height: 100%;
  padding-bottom: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--accent-background, var(--tr-background-list));
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  vertical-align: top;
  white-space: normal;
  scroll-margin: var(--ds-space-100, 8px);
}
@media only screen and (max-width: 750px) {
  .cYogZfEaHc9LfO {
    scroll-snap-align: center;
  }
}
@media print {
  .cYogZfEaHc9LfO {
    margin-bottom: var(--ds-space-200, 16px);
  }
}
.cYogZfEaHc9LfO.ic6fnjtC0cCyEB {
  flex-basis: auto;
  width: auto;
  max-width: fit-content;
  padding-bottom: var(--ds-space-0, 0);
}
.cYogZfEaHc9LfO.Dwa7b_mf6U_eZg {
  outline: 2px solid var(--ds-border-focused, #388bff);
}
.mac .cYogZfEaHc9LfO.Dwa7b_mf6U_eZg {
  outline-color: -webkit-focus-ring-color;
}
.mac.firefox .cYogZfEaHc9LfO.Dwa7b_mf6U_eZg {
  outline-color: AccentColor;
}
.cYogZfEaHc9LfO.SDI4MvShj3_wj8 {
  opacity: 0.4;
}
`, ""]);
// Exports
export var list = `cYogZfEaHc9LfO`;
export var collapsed = `ic6fnjtC0cCyEB`;
export var dropTarget = `Dwa7b_mf6U_eZg`;
export var isDragging = `SDI4MvShj3_wj8`;
export default ___CSS_LOADER_EXPORT___;
